{
  "times_in_zone": "Times in {{zone}}",
  "week_header": {
    "today": "Today",
    "prev_week": "Previous week",
    "next_week": "Next week"
  },
  "view_select": {
    "select": "Select",
    "week": "Week",
    "month": "Month",
    "agenda": "Day",
    "summary": "Summary"
  }
}
